import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-new-branch-office',
  templateUrl: './new-branch-office.page.html',
  styleUrls: []
})
export class NewBranchOfficePage implements OnInit {

  shopId: string;
  branchOfficeId: string;
  mapTouched: boolean = false;
  cities: any = [];
  zones: any = [];
  branch_offices: any = [];
  branchs_types: any = this.uService.type_branchs;
  coords: string;
  status: any = this.uService.status;

  newOrganizationForm: FormGroup = new FormGroup({
    city: new FormControl('', Validators.required),
    zone_id: new FormControl('', Validators.required),
    address: new FormControl('', Validators.required),
    house_number: new FormControl('', Validators.required),
    name_branch_office: new FormControl('', Validators.required),
    // type_br: new FormControl('', Validators.required),
    // status: new FormControl('', Validators.required),
    cost_center_name: new FormControl('', Validators.required),
    cost_center_code: new FormControl('', Validators.required),
  });

  // branchForm: FormGroup = new FormGroup({
  //   branch: new FormControl('')
  // })

  setCoords(coords: any){
    this.coords = coords;
  }

  createBranch(){
    this.mapTouched = true;

    if(this.newOrganizationForm.invalid){
      this.uService.validateForm(this.newOrganizationForm);
      return;
    }

    var body = {
      ...this.newOrganizationForm.value,
      organization_id: this.shopId,
      map: this.coords
    }
    this.mService.post_request('branch-office/create', body)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.router.navigate([`dashboard/business-details/${this.shopId}`]);
      }else{
        if(resp?.errors != undefined){
          resp.errors.forEach(element => {
            this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
          });
        }
      }
    })
  }

  editBranch(){
    this.mapTouched = true;

    if(this.newOrganizationForm.invalid){
      this.uService.validateForm(this.newOrganizationForm);
      return;
    }

    var body = {
      ...this.newOrganizationForm.value,
      organization_id: this.shopId,
      map: this.coords,
      id: this.branchOfficeId
    }
    body.city_id = body.city;

    this.mService.post_request('branch-office/update', body)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.router.navigate([`dashboard/business-details/${this.shopId}`]);
      }else{
        if(resp?.errors != undefined){
          resp.errors.forEach(element => {
            this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
          });
        }
      }
    })
  }

  getCities(){
    this.mService.get_request('cities/list')
    .subscribe((resp: any)=>{
      if (resp.status) {
        this.cities = resp.items;
        // this.newOrganizationForm.get('zone_id').setValue('');
        if(this.newOrganizationForm.get('city').value != ''){
          this.getZones();
        }
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getZones(){
    var fields: any = {
      city_id: this.newOrganizationForm.get('city').value
    }

    this.mService.get_request('zones/list', fields)
    .subscribe((resp: any)=>{
      if (resp.status) {
        this.newOrganizationForm.get('zone_id').enable();
        this.zones = resp.items;
        if(this.uService.newShop.city != undefined){
          this.newOrganizationForm.get('zone_id').setValue(this.uService.newShop.zone_id);
        }
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  // setBranch(){
  //   var id = this.branchForm.get('branch').value;

  //   this.branch_offices.forEach(element => {
  //     if(element.id_br == id){
  //       this.uService.newShop.id_br = element.id_br;
  //       this.uService.newShop.city = element.city_id;
  //       this.uService.newShop.zone_id = element.zone_id;
  //       this.uService.newShop.address = element.address;
  //       this.uService.newShop.house_number = element.house_number;
  //       this.uService.newShop.name_branch_office = element.name_branch_office;
  //       this.uService.newShop.type_br = element.type_br;
  //       this.uService.newShop.map = element.map;
  //     }
  //   });
  // }

  constructor(public uService: UtilsService, private router: Router, private mService: MainService, private toast: ToastrService, private activatedRoute: ActivatedRoute) {
    this.uService.newShop = {};
    this.newOrganizationForm.get('zone_id').disable();

    this.activatedRoute.params.subscribe((params: any)=>{
      if(params.id != undefined){
        this.shopId = params.id;
      };
      if(params.branchOfficeId != undefined){
        this.branchOfficeId = params.branchOfficeId;
        this.newOrganizationForm.get('zone_id').enable();

        this.mService.get_request('branch-office', { id: this.branchOfficeId })
        .subscribe((resp: any)=>{

          if(resp.status){
            this.newOrganizationForm.get('city').setValue(resp.item.city_id);
            this.getCities();
            this.newOrganizationForm.get('zone_id').setValue(resp.item.zone_id);

            this.newOrganizationForm.get('address').setValue(resp.item.address);
            this.newOrganizationForm.get('house_number').setValue(resp.item.house_number);
            this.newOrganizationForm.get('name_branch_office').setValue(resp.item.name_branch_office);
            // this.newOrganizationForm.get('type_br').setValue(resp.item.type_br);
            // this.newOrganizationForm.get('status').setValue(resp.item.status);
            this.newOrganizationForm.get('cost_center_name').setValue(resp.item.cost_center_name);
            this.newOrganizationForm.get('cost_center_code').setValue(resp.item.cost_center_code);
            this.uService.latLong2 = resp.item.map;
            this.coords = resp.item.map;
            this.uService.updateMap$.next(true);

            this.newOrganizationForm.get('city').setValidators(null);
            this.newOrganizationForm.get('zone_id').setValidators(null);
            this.newOrganizationForm.get('address').setValidators(null);
            this.newOrganizationForm.get('house_number').setValidators(null);
            // this.newOrganizationForm.get('name_branch_office').setValidators(null);
            // this.newOrganizationForm.get('type_br').setValidators(null);
            this.newOrganizationForm.get('status').setValidators(null);
            this.newOrganizationForm.get('cost_center_name').setValidators(null);
            this.newOrganizationForm.get('cost_center_code').setValidators(null);
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
            if(resp.message.includes('expirado')){
              this.uService.logOut$.next(true);
            }
          }
        })
      }else{
        this.getCities();
      }
    });
  }

  ngOnInit(): void {
  }

}
